/* eslint-disable max-len */
import { createRoot } from 'react-dom/client';
import React from 'react';
import * as Sentry from '@sentry/react';

import App from './App';
import reportWebVitals from './reportWebVitals';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: "https://383072a0d4718aedc21293b78cc9aa85@o4505931590074368.ingest.sentry.io/4506519028695040",
    integrations: [
      // eslint-disable-next-line new-cap
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: false,
      }),
      Sentry.replayCanvasIntegration(),
    ],
    // Session Replay
    // eslint-disable-next-line max-len
    replaysSessionSampleRate: 1.0, // Sets session replay sample rate to 100%. Consider lowering the rate in production for performance.
    replaysOnErrorSampleRate: 1.0, // Capture 100% of session replays when errors occur (useful for debugging).
  });
}

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
